import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import CartSummary from 'cart/CartSummary';
// eslint-disable-next-line import/no-cycle
import ItemNoEdit from 'common/components/item/ItemNoEdit';
import { isShipmentAdjustable } from 'profile/clubMembership/shipment/components/traditional/helpers';

const ShipmentItemsPricingFromProducts = (props) => {
  const { clubPackage, clubMemberShipment, clubMembership } = props;
  const { isPersonalizationBlock = false } = props;
  const { virtualCart } = clubMemberShipment;

  const settings = useSelector((state) => state.setting);

  // TODO - this is gross - but we really need something if there is no virtual shipment
  if (!virtualCart) {
    return null;
  }

  return (
    <div>
      <div className="c7-cart-items">
        {virtualCart.items.map((item) => (
          <ItemNoEdit item={item} key={item.id} settings={settings} />
        ))}
      </div>
      {isShipmentAdjustable(clubMemberShipment, clubPackage) && (
        <>
          {isPersonalizationBlock && (
            <a
              href={`/profile/club-membership/${clubMembership.id}/shipment`}
              className="c7-button-small c7-button-small--adjust"
            >
              Adjust your shipment
            </a>
          )}
          {!isPersonalizationBlock && (
            <Link
              to={`/profile/club-membership/${clubMembership.id}/shipment`}
              className="c7-button-small c7-button-small--adjust"
            >
              Adjust your shipment
            </Link>
          )}
        </>
      )}

      <br />
      <br />
      <CartSummary cart={virtualCart} settings={settings} />
    </div>
  );
};

export default ShipmentItemsPricingFromProducts;
